import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/context.js';
import Login from './pages/Login.js';
import AuthCallback from './pages/AuthCallback.js';
import AuthError from './pages/AuthError.js';
import Home from './pages/Home.js';
import Stock from './pages/Stock.js';
import StockDetail from './pages/StockDetail.js';
import OrderDay from './pages/OrderDay.js';
import OrderDayByBranch from './pages/OrderDayByBranch.js';
import TransferDay from './pages/TransferDay.js';
import TargetsImport from './pages/TargetsImport.js';
import Suggestions from './pages/Suggestions.js';
import POList from './pages/POList.js';
import PODetail from './pages/PODetail.js';
import PONew from './pages/PONew.js';
import TransferList from './pages/TransferList.js';
import TransferNew from './pages/TransferNew.js';
import RequestList from './pages/RequestList.js';
import RequestNew from './pages/RequestNew.js';
import RequestDetail from './pages/RequestDetail.js';
import Shell from './layout/Shell.js';

function Protected({ children }: { children: JSX.Element }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') {
    return <main className="grid min-h-screen place-items-center text-slate-500">...</main>;
  }
  if (status === 'anon') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

function Router() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/error" element={<AuthError />} />

      <Route
        element={
          <Protected>
            <Shell />
          </Protected>
        }
      >
        <Route path="/" element={<Home />} />
        <Route path="/order-day" element={<OrderDay />} />
        <Route path="/order-day-by-branch" element={<OrderDayByBranch />} />
        <Route path="/transfer-day" element={<TransferDay />} />
        <Route path="/stock" element={<Stock />} />
        <Route path="/stock/import" element={<TargetsImport />} />
        <Route path="/stock/:sku" element={<StockDetail />} />
        <Route path="/suggestions" element={<Suggestions />} />
        <Route path="/pos" element={<POList />} />
        <Route path="/pos/new" element={<PONew />} />
        <Route path="/pos/:id" element={<PODetail />} />
        <Route path="/transfers" element={<TransferList />} />
        <Route path="/transfers/new" element={<TransferNew />} />
        <Route path="/requests" element={<RequestList />} />
        <Route path="/requests/new" element={<RequestNew />} />
        <Route path="/requests/:id" element={<RequestDetail />} />
      </Route>

      <Route path="*" element={<div className="p-6">404</div>} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router />
    </AuthProvider>
  );
}
